import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { forwardRef } from "react";
import { generateCustomTextFieldStyle } from "../utils/date-picker-functions.es.js";
import { MobileDatePicker as MobileDatePicker$1 } from "../../../../node_modules/@mui/x-date-pickers/MobileDatePicker/MobileDatePicker.es.js";
const MobileDatePicker = forwardRef(function MobileDatePicker2({
  id,
  slotProps,
  disabled,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsx(MobileDatePicker$1, { slotProps: {
    textField: {
      id,
      ...generateCustomTextFieldStyle(disabled)
    },
    ...slotProps
  }, disabled, ...rest, ref });
});
export {
  MobileDatePicker
};
//# sourceMappingURL=mobile-date-picker.es.js.map
